import React from "react";
import { GenericDialog } from "../../../components/generic/GenericDialog";
import { Box, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import { GenericAvatar } from "../../../components/generic/GenericAvatar";

export const BroadcastMessageDetailsDialog = ({ openDialog, dialogDetails, handleCloseDialog }) => {
  const recipients = dialogDetails?.data?.recipients ?? [];
  return (
    <GenericDialog
      title={'Broadcast Details'}
      openDialog={openDialog}
      handleClose={() => handleCloseDialog()}
      width={'850px'}
    >
      <Stack spacing={2}>
        <Box>
          <Typography variant="subtitle2" fontWeight={600}>Date Sent:</Typography>
          <Typography>{dayjs(dialogDetails?.data?.created_at).format('MMMM D, YYYY')}</Typography>
        </Box>

        <Box>
          <Typography variant="subtitle2" fontWeight={600}>
            Recipients ({recipients.length} Total):
          </Typography>
          <Stack spacing={1} mt={1}>
            {/* {console.log('dialogDetails', dialogDetails)} */}
            {dialogDetails?.data?.is_sent_to_all ?
              <Stack direction="row" alignItems="center" spacing={1}>
                <GenericAvatar size={'42px'} />
                <Typography>All users</Typography>
              </Stack>
              :
              recipients?.slice(0, 3)?.map((user) => (
                <Stack direction="row" alignItems="center" spacing={1} key={user.id}>
                  <GenericAvatar location={user?.details?.profile_picture?.location} size={'42px'} />
                  <Typography>{user?.name}</Typography>
                </Stack>
              ))}
          </Stack>
        </Box>

        <Box>
          <Typography variant="subtitle2" fontWeight={600}>Title:</Typography>
          <Typography>{dialogDetails?.data?.title}</Typography>
        </Box>

        <Box>
          <Typography variant="subtitle2" fontWeight={600}>Message:</Typography>
          <Box sx={{ whiteSpace: 'normal', p: 0 }} className="ql-editor">
            <Typography
              component="div"
              dangerouslySetInnerHTML={{ __html: dialogDetails?.data?.message }}
            />
          </Box>
        </Box>

        <Box>
          <Typography variant="subtitle2" fontWeight={600}>Type:</Typography>
          <Typography>{dialogDetails?.data?.type}</Typography>
        </Box>
      </Stack>
    </GenericDialog>
  );
};